/**
 * Central wiring from a backend error to the <ErrorMessage> payload.
 * Automatically sets `persistent: true` when the backend code is in
 * the W11 persistent-codes set. Avoids per-hook duplication.
 *
 * Mirrors features/data-cloud/utils/cloudErrorPayload.ts from W10.
 */

import { isTrainingPersistentErrorCode } from './trainingPersistentErrorCodes';

export interface TrainingErrorPayload {
  message: string;
  code?: string;
  persistent: boolean;
  suggestion?: string;
}

interface BackendError {
  code?: string;
  error?: string;
  suggestion?: string;
}

export function trainingErrorPayloadFromError(err: BackendError | string | unknown): TrainingErrorPayload {
  if (typeof err === 'string') {
    return { message: err, persistent: false };
  }
  if (err && typeof err === 'object') {
    const e = err as BackendError;
    const code = e.code;
    return {
      message: e.error ?? 'An unknown error occurred',
      code,
      persistent: isTrainingPersistentErrorCode(code),
      suggestion: e.suggestion,
    };
  }
  return { message: 'An unknown error occurred', persistent: false };
}
